module.exports = __webpack_public_path__ + "img/dangan.fa29d14d.png";